<template>
    <div v-if="hasAuth('Admin')">
        <list-container :header="translate('uetsInbox.uetsAccounts')" v-show="!$route.params.id">
            <template v-slot:commands>
                <excel-exporter table-id="remproviderExport" :columns="columns" url="/uetsprovider/get" modelName="UetsProvider"  orderBy="UetsAddress"></excel-exporter>
                <!-- v-if="hasModule('UETS')" -->
                <button class="btn btn-primary" @click="$router.push({ name:'UetsProviderDetail', params: { id: '000000000000000000000000' } })">
                    {{translate('uetsInbox.newUetsAccount')}}
                </button>
            </template>
            <list :columns="columns" url="/uetsprovider/get" modelName="UetsProvider"  orderBy="IsActive desc">
            </list>
        </list-container>
        <router-view v-if="$route.params.id"/>
    </div>
    <div v-else class="alert alert-danger">
        {{translate('errors.notAuthorizedForTheProcess')}}
    </div>
</template>

<script>
import Vue from 'vue'
import list from '../components/List.vue'
import listContainer from '../components/ListContainer.vue'
import ExcelExporter from '../components/ExcelExporter.vue';


export default {
    data(){
        return {
            columns : [
                {
                    Key: "Name",
                    Title: this.translate('categoryList.columns.name'),
                    SortField: "Name"
                },
                {
                    Key: "IsActive",
                    Title: this.translate('categoryList.columns.active'),
                    SortField: "IsActive",
                    Class: "text-center",
                    Content(i) {
                        return Vue.filter('checkicon')(i.IsActive);
                    }
                }
            ]
        }
    },
    components: {
        list,ExcelExporter,
        listContainer
    },
    methods: {
        // select(i){
        //     console.log('Kayıt seçildi: ', i);
        //     this.$router.push('draft/' + i.Id);
        // }
    }
}
</script>